import { useParams } from 'react-router';
import { useLeague } from './useLeague';

export const useLeagueDataByParams = () => {
  const { leagueId } = useParams();
  const { data, isLoading } = useLeague(leagueId);

  return {
    data,
    isLoading,
  };
};
